import { useTranslation } from 'react-i18next';
import { getPastLoanRows } from '@modules/borrower/utils/getPastLoanRows';
import { InvestmentItem } from '@modules/investor/components/common/InvestmentItem';
const PastLoansTableMobile = ({ pastLoans }) => {
    const { t } = useTranslation();
    return (<div className="flex flex-col gap-4">
            {pastLoans.map((loan) => (<InvestmentItem key={loan.id} rows={getPastLoanRows(loan, t)}/>))}
        </div>);
};
export default PastLoansTableMobile;
